// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"40fd211a","206":"63b19374","354":"acfdba69","503":"0b3a706c","538":"8482e54b","767":"5416b664","784":"ce683efb","796":"1811493c","923":"525f5cba"}[chunkId] + ".chunk.css";
};